import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=dbf314fc&scoped=true&"
import script from "./FormHeader.vue?vue&type=script&lang=ts&"
export * from "./FormHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=dbf314fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf314fc",
  null
  
)

export default component.exports